/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs */

const en_admin_resources_resource_allocations_recurring_minimum_commitment = /** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurring Minimum Commitment`)
};

const de_admin_resources_resource_allocations_recurring_minimum_commitment = /** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederkehrende Mindestlaufzeit`)
};

const es_admin_resources_resource_allocations_recurring_minimum_commitment = /** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compromiso mínimo recurrente`)
};

const fr_admin_resources_resource_allocations_recurring_minimum_commitment = /** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engagement minimum récurrent`)
};

const nl_admin_resources_resource_allocations_recurring_minimum_commitment = /** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terugkerende minimale verbintenis`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_recurring_minimum_commitment = en_admin_resources_resource_allocations_recurring_minimum_commitment;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_recurring_minimum_commitment = en_admin_resources_resource_allocations_recurring_minimum_commitment;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_recurring_minimum_commitment = en_admin_resources_resource_allocations_recurring_minimum_commitment;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_recurring_minimum_commitment = en_admin_resources_resource_allocations_recurring_minimum_commitment;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_recurring_minimum_commitment = en_admin_resources_resource_allocations_recurring_minimum_commitment;

/**
* | output |
* | --- |
* | "Recurring Minimum Commitment" |
*
* @param {Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_recurring_minimum_commitment = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Recurring_Minimum_CommitmentInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
	return ro_admin_resources_resource_allocations_recurring_minimum_commitment(inputs)
});
export { admin_resources_resource_allocations_recurring_minimum_commitment as "admin.resources.resource_allocations.recurring_minimum_commitment" }